import { useEffect, useRef, useState } from "react";

import GuestImg  from "../../assets/images/conversations/ep-62-peter-varghese-guest.webp";
import ThumbImg from "../../assets/images/conversations/062.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";



/* ─────────────────────────────────────────────
   PREFIX: pv-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .pv-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  /* ── INNER ── */
  .pv-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO (2-col)
  ══════════════════════════════════════ */
  .pv-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .pv-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }

  /* LEFT */
  .pv-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .pv-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pv-hero__title.pv-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pv-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .pv-hero__spotify.pv-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pv-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }

  /* RIGHT — video thumbnail + play */
  .pv-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .pv-hero__right.pv-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail wrapper */
  .pv-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .pv-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .pv-yt-thumb:hover img {
    opacity: 0.85;
  }

  /* play button */
  .pv-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
   
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.25s ease, background 0.25s ease;
    pointer-events: none;
    
  }
  .pv-yt-thumb:hover .pv-yt-thumb__play {
    // transform: translate(-50%, -50%) scale(1.1);
    
  }
  .pv-yt-thumb__play img {
    width: 40px;
    height: 44px;
    margin-left: 4px; /* optical center for triangle */
    fill: #FFFFFF;
  }

  /* iframe (shown after click) */
  .pv-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .pv-yt-iframe-wrap iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .pv-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pv-body.pv-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pv-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
    .pv-body__para:last-child { margin-bottom: 0px;}
  .pv-body__key-label {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 12px;
  }
  .pv-body__key-item {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST
  ══════════════════════════════════════ */
  .pv-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pv-guest.pv-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pv-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .pv-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .pv-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .pv-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .pv-inner { padding-left: 32px; padding-right: 32px; }
    .pv-hero {     padding-top: 32px;padding-bottom: 48px;}
    .pv-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .pv-hero__title { font-size: 24px; }
    .pv-guest__title { font-size: 24px; margin-bottom: 24px; }
    .pv-guest__name {     font-size: 24px; margin-top: 18px;}
    .pv-hero__left {     gap: 16px;}
    .pv-guest__photo-bg { width: 260px; height: 300px; }
    .pv-body__para {   font-size: 14px;  margin-bottom: 12px;}
    .pv-body__key-item { font-size: 14px;  margin-bottom: 12px;}
    .pv-body {     padding-bottom: 48px;}
    .pv-guest {     padding-bottom: 48px;}
    .pv-yt-thumb__play img{  width: 30px; height: 32px;}
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
      .pv-hero__grid { grid-template-columns:  1fr; gap: 40px;}
    .pv-inner { padding-left: 16px; padding-right: 16px; }
    .pv-hero { padding-top: 51px; padding-bottom: 30px; }
 .pv-hero__left {  gap: 30px;}
    .pv-hero__title { font-size: 30px; }
    .pv-body__para,
    .pv-body__key-label,
    .pv-body__key-item { font-size: 16px;margin-bottom: 10px; }
    .pv-guest__title { font-size: 30px; margin-bottom: 20px; }
    .pv-guest__photo-bg { width: 100%; height: 386px; }
    .pv-guest__name { font-size: 24px; text-align:left;}
    .pv-body {  padding-bottom: 30px;}
    .pv-guest {         padding-bottom: 30px;}
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("pv-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE THUMBNAIL + PLAY BUTTON
───────────────────────────────────────────── */
const YT_VIDEO_ID = "QDyWCIGBFrM";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="pv-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 62 Peter Varghese"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="pv-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 62 Peter Varghese thumbnail" />
      <div className="pv-yt-thumb__play">
                       <img src={PlayIcon} />
       
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="pv-hero">
      <div className="pv-inner">
        <div className="pv-hero__grid">

          {/* LEFT */}
          <div className="pv-hero__left">
            <h1 ref={titleRef} className="pv-hero__title">
              EP 62 | Peter VARGHESE on China's Tech Dominance, Trump's America, &amp; the India-Australia Partnership.
            </h1>
            <div ref={spotifyRef} className="pv-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6qw1cHzfZJdrmPh3j0UAW9?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 62 Spotify Player"
              />
            </div>
          </div>

          {/* RIGHT — custom thumbnail + play */}
          <div ref={rightRef} className="pv-hero__right">
            <YouTubeEmbed />
          </div>

        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pv-body">
      <div className="pv-inner">
        <p className="pv-body__para">
          Can democracies compete with China's algorithmic hegemony in the energy transition?
        </p>
        <p className="pv-body__para">
          In this pivotal episode, we sit down with Peter Varghese AO, former head of Australia's Office of National Assessments (Australia's intelligence agency), former High Commissioner (Ambassador) to India, and former Australian Secretary of Foreign Affairs, for an unfiltered discussion about the new world order reshaping energy and technology.
        </p>
        <p className="pv-body__para">
          Varghese challenges conventional wisdom on self-reliance, warning that abandoning comparative advantage could make us "a heck of a lot poorer." He reveals why containing China is "not feasible," but allowing it to become the Indo-Pacific hegemon would resurrect the Middle Kingdom where "hierarchy was harmony."
        </p>
        <p className="pv-body__para">
          With Trump's America imposing 50% tariffs on India and creating "perceptions of unreliability," Varghese explores whether the Quad and AUKUS can survive, and why India-Australia cooperation on critical minerals and AI remains slower than anticipated despite evident synergies.
        </p>
        <p className="pv-body__key-label">Key Discussions:</p>
        <p className="pv-body__key-item">Why China's control of energy technology may be irreversible.</p>
        <p className="pv-body__key-item">The "salad days" of US leadership and what comes after Trump.</p>
        <p className="pv-body__key-item">How AI will disrupt diplomacy, universities, and the very concept of expertise.</p>
        <p className="pv-body__key-item">The hidden risks in post-COVID self-sufficiency drives.</p>
        <p className="pv-body__key-item">What policymakers consistently get wrong about the China-India-Australia triangle.</p>
        <p className="pv-body__para" >
          Co-hosted by Ravin Mirchandani and special guest co-host Ritu David (ex-intelligence analyst, seconded to CIA Afghanistan), this episode delivers rare insights from one of Australia's most experienced strategic thinkers on navigating the collision of energy transition, AI disruption, and great power competition. Essential listening for anyone working in energy, technology, or international business in the Indo-Pacific.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pv-guest">
      <div className="pv-inner">
        <h2 className="pv-guest__title">Our Guest</h2>
        <div>
          <div className="pv-guest__photo-bg">
            <img src={GuestImg} alt="Peter Varghese" />
          </div>
          <p className="pv-guest__name">Peter VARGHESE</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep62PeterVarghese() {
  return (
    <>
      <style>{CSS}</style>
      <div className="pv-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}